import * as React from 'react';
import { SVGProps } from 'react';

const IconFolder3DCubeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 1.7A.7.7 0 0 1 .7 1h5.886a1 1 0 0 1 .707.293l1.414 1.414A1 1 0 0 0 9.414 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V1.7Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M0 3.7A.7.7 0 0 1 .7 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V3.7Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M13.143 10.714H7.07V7.857h6.072l1.786-1.786V8.93l-1.786 1.785Z"
      fill="var(--color-bg-success)"
    />
    <path
      d="M13.143 12.5H7.07V9.643h6.072l1.786-1.786v2.857L13.143 12.5Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M13.143 13.929H7.07v-1.786h6.072l1.786-1.786v1.786l-1.786 1.786Z"
      fill="var(--color-bg-alert)"
    />
    <path
      d="M7.071 8 9 6.071h5.929L13.008 8H7.07Z"
      fill="var(--color-bg-success)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.65 5.214h7.136v7.136l-2.436 2.436H6.214V7.65L8.65 5.214Zm.414 1L7.921 7.357h5.015l1.143-1.143H9.064Zm5.722.707-1.143 1.143v5.015l1.143-1.143V6.92Zm-7.572 6.865V8.357h5.429v5.429H7.214Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconFolder3DCubeSizeS;
